import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		style: { fill: "none" },
		d: "M0,0H13V13H0Z"
	}), /* @__PURE__ */ _jsx("path", {
		className: "icon",
		d: "M11.22,11.281a.535.535,0,0,1-.538.532H3.152a.535.535,0,0,1-.538-.532V6.489H1l5.555-5a.542.542,0,0,1,.724,0l5.555,5H11.22Z",
		transform: "translate(-0.417 -0.563)"
	})]
});
export default SvgHome;
